<ng-container *transloco="let t;">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 40rem;">
            <breadcrumb [items]='[{ label: t("header.frontpage"), route: "/"}, { label: t("header.profilenavtitle")} ]'>
            </breadcrumb>
            <div class="content-box p-4 mb-4">
                <h3>{{ t("patientprofile.info.title") }}</h3>
                <div class="mb-2">                    
                    <span class="fw-bold d-block mb-1">
                        {{ t("patientprofile.info.personnumber")}}
                    </span>
                    <div class="d-flex align-items-center">
                        <p class="p-0 m-0">{{ maskedCpr }}</p>                   
                        <button type="button" class="btn btn-sm wp-btn-outline ms-auto text-nowrap" (click)="toggleCprVisibility()">
                            {{ cprVisible ? t('patientprofile.info.hidecpr') : t('patientprofile.info.showcpr') }}
                        </button>                                             
                    </div>                    
                </div>
                <div class="mb-3">                    
                    <span class="fw-bold d-block mb-1">
                        {{ t("patientprofile.info.firstname")}}
                    </span>
                    <p class="p-0 m-0">{{patientInfo?.firstName}}</p>                    
                </div>
                <div class="mb-3">                     
                    <span class="fw-bold d-block mb-1">{{ t("patientprofile.info.lastname") }}</span>
                    <p class="p-0 m-0">{{patientInfo?.lastName}}</p>                    
                </div>
            </div>

            <div class="content-box mb-4" id="logs">
                <h3>{{ t("patientprofile.logs.title") }}</h3>
                <p>{{ t("patientprofile.logs.text") }}</p>
                <access-logs [accessLogs]="accessLogs"></access-logs>
                <div class="row align-items-center">
                    <div class="col-4 text-start">
                        <button *ngIf="currentPage !== 1" type="button" class="btn btn-sm wp-btn-outline"
                            (click)="paginatePage(false)" [attr.aria-label]="t('patientprofile.logs.previouspage')"
                            [disabled]="isLoading" [attr.aria-disabled]="isLoading">
                            <svg class=" icon-sm icon-primary">
                                <use xlink:href="assets/icons.svg#icon-chevron-left"></use>
                            </svg>
                            <span class="d-none d-md-inline-block">
                                {{ t("patientprofile.logs.previouspage")
                                }}</span>
                        </button>
                    </div>
                    <div class="col-4 text-center">
                        <div *ngIf="!isLoading">
                            {{ t("patientprofile.logs.page") }} {{currentPage}}
                        </div>
                        <loading-spinner-border *ngIf="isLoading" size="btn-sm" />
                    </div>
                    <div class="col-4 text-end">
                        <button type="button" class="btn btn-sm wp-btn-outline" (click)="paginatePage(true)"
                            [attr.aria-label]="t('patientprofile.logs.nextpage')" [disabled]="isLoading"
                            [attr.aria-disabled]="isLoading">
                            <span class="d-none d-md-inline-block">{{ t("patientprofile.logs.nextpage") }}</span>
                            <svg class="icon-sm icon-primary">
                                <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="hasConsent">
                <div class="content-box" id="personalData">
                    <h3 [innerHTML]="t('patientprofile.personaldata.title')"></h3>
                    <p [innerHTML]="t('patientprofile.personaldata.text')"></p>
                    <div class="text-end">
                        <button type="button" class="btn wp-btn" data-bs-toggle="modal"
                            data-bs-target="#deleteDataDialog">
                            <span class="me-2">{{ t("patientprofile.personaldata.deletedata") }}</span>
                            <svg class="icon icon-dark-bg icon-sm">
                                <use xlink:href="assets/icons.svg#icon-delete"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </ng-container>

        </div>

    </div>

    <div class="modal fade" id="deleteDataDialog" aria-labelledby="deleteDataDialogLabel" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1">
        <delete-data-dialog [userHasConsent]="hasConsent"></delete-data-dialog>
    </div>

</ng-container>